import { SvgIconProps } from '@mui/material';
import { useFeatureFlag } from 'providers';
import FeastImage from 'assets/images/img-feast.jpg';
import RedeemAndSavourImage from 'assets/images/img-redeem-and-savour-1.jpg';

const Feast = ({ height = '170', width = '173', className }: SvgIconProps) => {
  const allowSpinToWin = useFeatureFlag('allowSpinToWin');

  return (
    <>
      {allowSpinToWin ? (
        <svg viewBox="0 0 254 249" width={width} height={height} fill="none" className={className}>
          <path
            d="M18.184 176.572c-20.76-33.613-24.776-78.14-6.674-114.85 4.887-9.913 12.385-18.291 20.06-26.262 9.224-9.587 19.008-18.905 30.694-25.291C88.818-4.348 133.717-.7 162.162 5.053c141.599 28.646 112.061 275.874-37.897 240.49-26.29-6.205-50.102-19.974-72.774-34.61-13.635-8.807-24.86-20.681-33.307-34.361Z"
            fill="url(#feast_svg_a)"
          />
          <defs>
            <pattern id="feast_svg_a" patternContentUnits="objectBoundingBox" width={1} height={1}>
              <use xlinkHref="#feast_svg_b" transform="scale(.0006 .00056)" />
            </pattern>
            <image id="feast_svg_b" width={1654} height={1774} xlinkHref={FeastImage} />
          </defs>
        </svg>
      ) : (
        <svg viewBox="0 0 254 249" width={width} height={height} fill="none" className={className}>
          <path
            d="M18.184 176.572c-20.76-33.613-24.776-78.14-6.674-114.85 4.887-9.913 12.385-18.291 20.06-26.262 9.224-9.587 19.008-18.905 30.694-25.291C88.818-4.348 133.717-.7 162.162 5.053c141.599 28.646 112.061 275.874-37.897 240.49-26.29-6.205-50.102-19.974-72.774-34.61-13.635-8.807-24.86-20.681-33.307-34.361Z"
            fill="url(#redeemAndSavour_svg_a)"
          />
          <defs>
            <pattern
              id="redeemAndSavour_svg_a"
              patternContentUnits="objectBoundingBox"
              width={1}
              height={1}
            >
              <use xlinkHref="#redeemAndSavour_svg_b" transform="scale(.0006 .00056)" />
            </pattern>
            <image
              id="redeemAndSavour_svg_b"
              width={1654}
              height={1774}
              xlinkHref={RedeemAndSavourImage}
            />
          </defs>
        </svg>
      )}
    </>
  );
};

export default Feast;
